import { render, staticRenderFns } from "./ViewResellerDevices.vue?vue&type=template&id=01fb32da&scoped=true&"
import script from "./ViewResellerDevices.vue?vue&type=script&lang=js&"
export * from "./ViewResellerDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb32da",
  null
  
)

export default component.exports